import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
    readonly baseURL = DDP_ENV.patientUrl;

    constructor(private _http: Http, private cookieService: CookieService) {}

    getAllAppointments(page, status, size, regExp) {
        console.log('Inside get Transaction');
        return this._http.get(this.baseURL + '/app/appointment?page=' + page + '&size=' + size +'&regexPattern='+regExp , this.buildHeaders());
    }

    getTransactionbyAppointments(id) {
        console.log('Inside get appointment Transaction');
        return this._http.get(this.baseURL + '/app/transactions/appointment/'+id, this.buildHeaders());
    }

    private buildHeaders(): any {
        const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
        return new RequestOptions({ headers: headers });
    }

}
